export * from './typeof';
export * from './color';
export * from './number';
export * from './pattern';
export * from './validate';
export * from './date';

/**
 * 将路径中重复的正斜杆替换成单个斜杆隔开的字符串
 * @param path 要处理的路径
 * @returns {string} 将/去重后的结果
 */
export const uniqueSlash = (path: string) => path.replace(/(?<!:)\/{2,}/g, '/');

/**
 * 替换url的指定参数
 * @param {*} url 需要替换的url
 * @param {*} name 参数名称
 * @param {*} value 替换的值
 */
export const replaceQueryString = (url: string, name: string, value: string) => {
  const re = new RegExp(`${name}=[^&]*`, 'gi');
  return url.replace(re, `${name}=${value}`);
};

/**
 * 获取assets静态资源 银行
 */
export const getAssetsFile = (filename: string, type = 'jpg') => {
  const filenameArr = filename.split('-');
  return new URL(`../../assets/images/${filenameArr[0]}/${filenameArr[1]}.${type}`, import.meta.url).href;
};

/**
 * 等待
 * @param {number} delay 等待时间
 */
export const sleep = (delay: number) => new Promise(resolve => setTimeout(resolve, delay));

/**
 * 获取比特率
 * @param {number} v bit
 */
export const getBitrate = (v: number) => {
  // PB
  if (v > 1000 * 1000 * 1000 * 1000) {
    return `${Number(v / 1000.0 / 1000 / 1000 / 1000).toFixed(2)}Pbps`;
  }
  // TB
  if (v > 1000 * 1000 * 1000) {
    return `${Number(v / 1000.0 / 1000 / 1000).toFixed(2)}Tbps`;
  }
  // GB
  if (v > 1000 * 1000) {
    return `${Number(v / 1000.0 / 1000).toFixed(2)}Gbps`;
  }
  // MB
  if (v > 1000) {
    return `${Number(v / 1000.0).toFixed(2)}Mbps`;
  }
  return `${Number(v).toFixed(2)}Kbps`;
};

/**
 * @description 处理首字母大写 abc => Abc
 * @param str
 */
export const toUpStr = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * 渲染菜单至树形控件
 * @param {Array} menus 所有菜单
 * @param {Number | null} parentId 父级菜单ID
 * @param {number[]|string[]} keyPath ID路径
 */
export const formatMenu2Tree = (
  menus: ApiMenu.MenuListResult,
  parentId: number | null = null,
  keyPath: (string | number)[] = []
): any[] => {
  const pid = parentId === null ? 0 : parentId;
  return menus
    .filter(item => item.pid === pid)
    .map(item => {
      const _keyPath = keyPath.concat(pid || []);
      const arr = formatMenu2Tree(menus, item.id, _keyPath);
      return Object.assign(item, {
        keyPath: _keyPath,
        label: item.name,
        key: item.id,
        value: item.id,
        children: arr.length ? arr : null
      });
    });
};

/**
 * @description 修改地址成本地地址
 * @param url
 */
const isProd = import.meta.env.PROD;
export const tolocalUrl = (url: string) => {
  if (isProd) {
    return url.replace('http:', window.location.protocol).replace('https:', window.location.protocol);
  }
  let retURl = url;
  try {
    retURl = new URL(url.replace('//image', '/image')).pathname;
  } catch {}
  return retURl;
};
